import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { AuthenticationEvent } from './authentication_events';

@Injectable({ providedIn: 'root' })
export class AuthenticationEventProvider extends DomainEventProvider<AuthenticationEvent> {}
